var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerVistaBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9152_11914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8926 15.3846V3.07692C36.8926 1.37759 38.2702 0 39.9695 0C41.6688 0 43.0464 1.37759 43.0464 3.07692V15.3846C43.0464 17.084 41.6688 18.4615 39.9695 18.4615C38.2702 18.4615 36.8926 17.084 36.8926 15.3846Z",
    fill: "#3B6CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8926 76.9232V64.6155C36.8926 62.9162 38.2702 61.5386 39.9695 61.5386C41.6688 61.5386 43.0464 62.9162 43.0464 64.6155V76.9232C43.0464 78.6225 41.6688 80.0001 39.9695 80.0001C38.2702 80.0001 36.8926 78.6225 36.8926 76.9232Z",
    fill: "#3B6CCF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3846 43.1077L3.07692 43.1077C1.37759 43.1077 -6.02162e-08 41.7301 -1.34497e-07 40.0307C-2.08777e-07 38.3314 1.37759 36.9538 3.07692 36.9538L15.3846 36.9538C17.084 36.9538 18.4615 38.3314 18.4615 40.0307C18.4615 41.7301 17.084 43.1077 15.3846 43.1077Z",
    fill: "#3B6CCF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9227 43.1077L64.615 43.1077C62.9157 43.1077 61.5381 41.7301 61.5381 40.0307C61.5381 38.3314 62.9157 36.9538 64.615 36.9538L76.9227 36.9538C78.622 36.9538 79.9996 38.3314 79.9996 40.0307C79.9996 41.7301 78.622 43.1077 76.9227 43.1077Z",
    fill: "#3B6CCF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4401 24.81L11.7372 16.1071C10.5356 14.9055 10.5356 12.9573 11.7372 11.7557C12.9388 10.5541 14.887 10.5541 16.0887 11.7557L24.7915 20.4585C25.9931 21.6601 25.9931 23.6083 24.7915 24.81C23.5899 26.0116 21.6417 26.0116 20.4401 24.81Z",
    fill: "#3B6CCF",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9547 68.3241L55.2519 59.6213C54.0503 58.4197 54.0503 56.4715 55.2519 55.2698C56.4535 54.0682 58.4017 54.0682 59.6033 55.2698L68.3062 63.9727C69.5078 65.1743 69.5078 67.1225 68.3062 68.3241C67.1046 69.5257 65.1564 69.5257 63.9547 68.3241Z",
    fill: "#3B6CCF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7477 59.6209L16.0449 68.3238C14.8432 69.5254 12.895 69.5254 11.6934 68.3238C10.4918 67.1222 10.4918 65.174 11.6934 63.9724L20.3963 55.2695C21.5979 54.0679 23.5461 54.0679 24.7477 55.2695C25.9493 56.4711 25.9493 58.4193 24.7477 59.6209Z",
    fill: "#3B6CCF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2624 16.107L59.5595 24.8099C58.3579 26.0115 56.4097 26.0115 55.2081 24.8099C54.0065 23.6083 54.0065 21.6601 55.2081 20.4585L63.9109 11.7556C65.1125 10.554 67.0607 10.554 68.2624 11.7556C69.464 12.9572 69.464 14.9054 68.2624 16.107Z",
    fill: "#3B6CCF",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9152_11914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerVistaBlue);
export default __webpack_public_path__ + "static/media/spinner-vista-blue.b877b95a39fc8d29e278076558a35059.svg";
export { ForwardRef as ReactComponent };